
  import {Component, Prop, Vue} from "vue-property-decorator";
  import CarNumber from "@/components/CarNumber.vue";
  import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";

  @Component({
    components: {
      CarNumber,
    }
  })
  export default class AppMediaPopupInfo extends Vue {
    @Prop() mediaInfo: IAppMediaPopup.IMediaInfo
  }
